<div style="height: 100%;display: flex; flex-direction: row;" class="app-page">


  <div style="display: block; width: 300px; padding: 10px; border: 1px solid gray; height: 1000px;">
    <!--         <label style="font-family: Rubik;">FILTER</label> -->
    <form [formGroup]="searchForm" style="display: flex; flex-direction: column;">

      <mat-form-field appearance="fill">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="PlayerLastName" placeholder="Last name">
        <mat-hint>Use * as wildcard</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>First name</mat-label>
        <input matInput formControlName="PlayerFirstName" placeholder="First name">
        <mat-hint>Use * as wildcard</mat-hint>
      </mat-form-field>&nbsp;
      <mat-form-field appearance="fill" style="font-size: small;">
        <mat-label>Positions</mat-label>
        <mat-select formControlName="PositionIds" id="PositionIds" multiple>
          <mat-option value="1">Goaltender</mat-option>
          <mat-option value="2">Defender</mat-option>
          <mat-option value="3">LW</mat-option>
          <mat-option value="4">Forward</mat-option>
          <mat-option value="5">Center</mat-option>
          <mat-option value="6">RW</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Year of birth</mat-label>
        <mat-select formControlName="YearsOfBirth" id="YearsOfBirth" multiple>
          @for (year of availableBirthYears; track year) {
            <mat-option [value]="year">{{year}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Shoots/glove</mat-label>
        <mat-select formControlName="ShootIds" id="ShootIds" multiple>
          <mat-option value="1">Left</mat-option>
          <mat-option value="2">Right</mat-option>
        </mat-select>
      </mat-form-field>

      @if (this.reportMasterdata) {
        <mat-form-field appearance="fill">
          <mat-label>Projection</mat-label>
          <mat-select formControlName="Projections" id="Projections" multiple>
            @for (proj of this.reportMasterdata.Projection; track proj) {
              <mat-option [value]="proj.Ranking">
                {{ proj.Text}}@if (proj.Hidden) {
                <span style="color: gray;"> (hidden)</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (this.reportMasterdata) {
      <mat-form-field appearance="fill">
        <mat-label>Capacity</mat-label>
        <mat-select formControlName="Capacities" id="Capacities" multiple>
          @for (proj of this.reportMasterdata.Capacity; track proj) {
            <mat-option [value]="proj.Ranking">
              {{ proj.Text}}
              @if (proj.Hidden) {
                <span style="color: gray;"> (hidden)</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (this.reportMasterdata?.PlayerTypeEnabled) {
      <mat-form-field appearance="fill">
        <mat-label>Player type</mat-label>
        <mat-select formControlName="PlayerTypes" id="PlayerTypes" multiple>
          @for (type of this.reportMasterdata.PlayerType; track type) {
            <mat-option [value]="type.Ranking">
              {{ type.Text}}
              @if (type.Hidden) {
                <span style="color: gray;"> (hidden)</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (this.reportMasterdata) {
      <mat-form-field appearance="fill">
        <mat-label>Source</mat-label>
        <mat-select formControlName="ScoutingSources" id="ScoutingSources" multiple>
          @for (source of this.reportMasterdata.ScoutingSource; track source) {
            <mat-option [value]="source.ScoutingSourceId">
              {{ source.Text}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field appearance="fill">
      <mat-label>Report date from</mat-label>
      <input matInput [matDatepicker]="pickerfrom" formControlName="minReportDate" name="minReportDate">
      <mat-datepicker-toggle matSuffix [for]="pickerfrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerfrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Report date to</mat-label>
      <input matInput [matDatepicker]="pickerto" formControlName="maxReportDate" name="maxReportDate">
      <mat-datepicker-toggle matSuffix [for]="pickerto"></mat-datepicker-toggle>
      <mat-datepicker #pickerto></mat-datepicker>
    </mat-form-field>


    <mat-form-field appearance="fill">
      <mat-label>Max no of items</mat-label>
      <mat-select formControlName="MaxHits" id="MaxHits">
        <mat-option selected value="50">50</mat-option>
        <mat-option value="100">100</mat-option>
        <mat-option value="200">200</mat-option>
        <mat-option value="500">500</mat-option>

      </mat-select>
    </mat-form-field>
    <br />
    <a mat-raised-button color="primary" (click)="this.loadFlow()">SEARCH</a>
  </form>
</div>

<!--   <div *ngIf="this._flowitems!=null && this._flowitems.length==0"
style="font-family: Roboto; margin: 20px; color: gray;">
NO ITEMS FOUND FOR THE SELECTED FILTERS
</div> -->

@if (this.isBusy()) {
  <mat-progress-bar mode="indeterminate" style="margin-top: 50px;"></mat-progress-bar>
}


@if (this.isBusy()==false) {
  <div
    style="display: flex; flex-flow: column; justify-content: center; min-height: 100%; overflow-y: scroll; justify-content: start; ">
    @if (this.isBusy()==false || this._flowitems!==null || this._flowitems.length>0) {
      <app-report-search-result-overview [ResultOverview]="this.SearchResultOverview"
        style="margin-left: 20px;">
      </app-report-search-result-overview>
    }
    <div style="display: flex; flex-flow: row wrap; justify-content: center;  overflow-y: scroll; ">
      @for (item of this._flowitems; track trackByFn($index, item)) {
        @if (item.FlowItemType=='SCREPORT') {
          <app-report-card [Report]="item"></app-report-card>
        }
        @if (item.FlowItemType=='PLAYERNOTE') {
          <app-note-card [Note]="item"></app-note-card>
        }
      }
    </div>
  </div>
}

</div>